module.exports = __webpack_public_path__ + "img/tratamiento-cpap.4e8c4766.jpg";